export enum EventKind {
  PLACE_ENTERED = "place_entered",
  PLACE_LEFT = "place_left"
}

export const EVENT_KIND_TRANSLATIONS = {
  [EventKind.PLACE_ENTERED]: "Ort betreten",
  [EventKind.PLACE_LEFT]: "Ort verlassen"
}
